import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box } from '@chakra-ui/react';
import FieldToolTip from '@/components/forms/new/FieldToolTip';
import { Field } from 'formik';
import DropDown from '@/components/forms/new/formikFormFields/DropDown';
import {
    formLabelStyling,
    stackStyling,
} from '@/components/forms/new/formStyles';
import walkthroughIds from '../../walkthroughIds';
import Platforms from '@/utils/platforms';

const UserPlatformDropdown = ({
    errors,
    touched,
    darkMode,
    availablePlatforms,
    platformDropdown,
    setPlatformDropdown,
    setAssigningPlatformUserId,
}) => {
    const platformList = availablePlatforms.map((platform) => ({
        id: platform.id,
        name: Platforms[platform.id]?.name,
    }));

    const handleSelectChange = (item) => {
        setPlatformDropdown(item.id);
        setAssigningPlatformUserId(undefined);
    };

    const [isHovered, setIsHovered] = useState(false);

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!errors.outboundCallerId && touched.outboundCallerId}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" sx={{ ...stackStyling(), width: '740px' }}>
                <Box width={190}>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Platform
                    </FormLabel>
                </Box>
                <Field
                    component={DropDown}
                    id="availablePlatforms"
                    name="availablePlatforms"
                    shownValue="name"
                    darkMode={darkMode}
                    currentId={platformDropdown}
                    handleSelectChange={handleSelectChange}
                    data={platformList}
                    data-walkthroughid={
                        walkthroughIds.edit.ufVoicePolicyDropdown
                    }
                />
                {isHovered && (
                    <FieldToolTip
                        label="Select a Platform to view or assign associtated users to selected Platform."
                        ariaLabel="users-platform-dropdown-tooltip"
                        right="25px"
                        top="23px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default UserPlatformDropdown;
